import { TAnyType } from '@affstore-ds/types'

import { DEFAULT_COOKIE_PATH } from '../constants'

interface CookieAttributesInterface {
  /**
   * Define when the cookie will be removed. Value can be a Number
   * which will be interpreted as days from time of creation or a
   * Date instance. If omitted, the cookie becomes a session cookie.
   */
  expires?: string | number | Date | undefined

  /**
   * Define the path where the cookie is available. Defaults to '/'
   */
  path?: string | undefined

  /**
   * Define the domain where the cookie is available. Defaults to
   * the domain of the page where the cookie was created.
   */
  domain?: string | undefined

  /**
   * A Boolean indicating if the cookie transmission requires a
   * secure protocol (https). Defaults to false.
   */
  secure?: boolean | undefined

  /**
   * Asserts that a cookie must not be sent with cross-origin requests,
   * providing some protection against cross-site request forgery
   * attacks (CSRF)
   */
  sameSite?: 'strict' | 'Strict' | 'lax' | 'Lax' | 'none' | 'None' | undefined

  /**
   * An attribute which will be serialized, conformably to RFC 6265
   * section 5.2.
   */
  [property: string]: TAnyType
}

export const setCookie = (name: string, value: string, options: CookieAttributesInterface = {}) => {
  const nextOptions = { ...options, path: options.path || DEFAULT_COOKIE_PATH }
  const { expires } = nextOptions

  if (typeof expires === 'number' && expires) {
    const d = new Date()

    d.setTime(d.getTime() + expires * 1000)
    nextOptions.expires = d.toUTCString()
  }

  const nextValue = encodeURIComponent(value)

  // eslint-disable-next-line unicorn/no-document-cookie
  document.cookie = Object.entries(nextOptions).reduce((response, [key, value_]) => {
    const preparedValue = value_ === true ? '' : `=${value_}`

    return `${response}; ${key}${preparedValue}`
  }, `${name}=${nextValue}`)
}

// получает значение куки
export const getCookie = (name: string) => {
  const results = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`)

  if (results) {
    return unescape(results[2])
  }

  return null
}

export const deleteCookie = (name: string) => {
  // eslint-disable-next-line unicorn/no-document-cookie
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`
}
